import React, {FC, useEffect} from 'react';
import {getErrorFromCode} from '../../data/errorCodes';
import styles from './ErrorBox2.module.css';

type UiType = 'minimal' | 'standard';
interface Props {
  errorCodes: string[];
  className?: string;
  clearErrors: () => void;
  uiType?: UiType;
}

const FADE_OUT_TIMEOUT = 5000;

const ErrorBox2: FC<Props> = ({
  errorCodes,
  className,
  clearErrors,
  uiType = 'standard',
}: Props) => {
  useEffect(() => {
    if (errorCodes.length > 0) {
      setTimeout(() => {
        clearErrors();
      }, FADE_OUT_TIMEOUT);
    }
  }, [errorCodes.length]);

  const getRootClass = () => {
    switch (uiType) {
      case 'minimal':
        return styles.minimal;
      case 'standard':
      default:
        return styles.standard;
    }
  };

  const getErrorsText = () => {
    return errorCodes.map((errorCode, index) => {
      if (index + 1 !== errorCodes.length) {
        return getErrorFromCode(errorCode) + ', ';
      } else {
        return getErrorFromCode(errorCode);
      }
    });
  };

  if (errorCodes.length === 0) {
    return null;
  }
  return (
    <div
      className={`${styles.container} ${getRootClass()} ${
        className ? className : ''
      }`}>
      <p className={styles.text}>{getErrorsText()}</p>
    </div>
  );
};

export default ErrorBox2;
